import { routes } from '@linqpal/models'

export const getGuestPaymentMethod = async (data: any) => {
  const response = await routes.guest.paymentInfo(data)
  return response
}
